import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Input } from "antd";

import AdminTable from "../../components/Table/AdminTable/AdminTable";
import { positionConfig } from "./config/positionConfig";

import usePositionService from "../../services/PositionAdmin/positionService";
import PivotLoading from "../../components/Loading/PivotLoading";

const { Search } = Input;

const Positions = () => {
  const { adminAddPos } = useSelector((state) => state.generalSlice || {});
  const { details: profile, account_types = [] } = useSelector(
    (state) => state.accountDetailSlice
  );
  const isSuperAdmin =
    profile?.account_type === "Super Admin" ||
    account_types.includes("superadmin") ||
    account_types.includes("xadmin");

  const [searchValue, setSearchValue] = useState("");

  const {
    getAllPosition,
    getAllApprovers,
    positionLoading,
    positionResponse,
    approverLoading,
    approverResponse,
    addPosition,
    editPosition,
    addPositionLoading,
    editPositionLoading,
  } = usePositionService();

  const handleRefresh = (search = "") => {
    getAllPosition(search);
    getAllApprovers();
  };

  useEffect(() => {
    handleRefresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = (value) => {
    setSearchValue(value);
    handleRefresh(value);
  };

  const mappedPosData =
    (positionResponse?.data || []).map((item, index) =>
      positionConfig.dataMapper(item, index)
    ) || [];

  const mappedApprover =
    (approverResponse?.data || []).map((item, index) =>
      positionConfig.appDataMapper(item, index)
    ) || [];

  const approverSelectItems = [...mappedApprover, { label: "None", name: 0 }];

  const columns = isSuperAdmin
    ? positionConfig.columns
    : positionConfig.columns.filter(
        (col) => col.key !== "employees_count"
      );

  const formFields = [
    ...positionConfig.formFields,
    {
      label: "Approver",
      name: "approver_id",
      type: "select",
      selectItems: approverSelectItems,
    },
  ];

  const pageLoading = positionLoading || approverLoading;
  const submitLoading = addPositionLoading || editPositionLoading || false;

  const handleAdd = addPosition || (async () => {});
  const handleEdit = editPosition || (async () => {});

  const adminPosData = {
    position: mappedPosData ? [...mappedPosData] : [],
    approvers: mappedApprover ? [...mappedApprover] : [],
  };

  return (
    <>
      {pageLoading && <PivotLoading />}
      {!pageLoading && (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h1>Manage Positions</h1>
            <Search
              placeholder="Search positions..."
              value={searchValue}
              size="large"
              allowClear
              enterButton
              onSearch={handleSearch}
              onChange={(e) => {
                const val = e.target.value;
                setSearchValue(val);
                if (val === "") {
                  handleRefresh("");
                }
              }}
              style={{ marginBottom: 16, maxWidth: 500 }}
            />
          </div>

          <AdminTable
            tableColumn={columns}
            tableData={mappedPosData}
            tableType="adminPosition"
            responseData={adminPosData}
            popupSlice={adminAddPos} // make sure this matches your generalSlice key
            popupName="adminAddPos" // this should match the popup key you use in Redux
            docuType="Position"
            formFields={formFields}
            onRefresh={() => handleRefresh(searchValue)}
            onAdd={handleAdd}
            onEdit={handleEdit}
            onAddBulk={null} // positions probably don’t have bulk add, can keep null
            submitLoading={submitLoading}
            isEmployee={false}
            positionData={null} // not needed here; only used for employee positions group
          />
        </>
      )}
    </>
  );
};

export default Positions;
